import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule }from '../../ng-zorro-antd/ng-zorro-antd.module';

import { LaboratorioComponent } from './laboratorio.component';
import { LancamentoLaboratorioComponent } from './lancamento-laboratorio/lancamento-laboratorio.component';



@NgModule({
  declarations: [LaboratorioComponent, LancamentoLaboratorioComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    NgZorroAntdModule,
  ]
})
export class LaboratorioModule { }
